// Application routes
const RoutePaths = {
  HOME: '/',
  AFFILIATES: '/affiliates',
  BLOGS: '/blogs',
  CREATE_BLOG: '/blogs/create',
  EDIT_BLOG: '/blogs/edit/:id',
  AFFILIATES_PENDING_APPROVAL: '/pending-affiliates',
  APPROVED_AFFILIATES: '/approved-affiliates',
  AFFILIATE_DETAILS: '/affiliate/:id',
  LOGIN: '/login',
  LOGOUT: '/logout',
  INVENTORYSYNC: '/inventorysync',
};

export default RoutePaths;
